import React, {createContext, useContext, useReducer} from 'react'
import {OverheadCameraDeviceOverviewReducer} from "../reducer/OverheadCameraDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const OverheadCameraDeviceOverviewContext = createContext();

const OverheadCameraDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        asmlComponentInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(OverheadCameraDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }
    return (
        <OverheadCameraDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </OverheadCameraDeviceOverviewContext.Provider>
    )
}

export default OverheadCameraDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/context/OverheadCameraDeviceOverviewContext.js